import { registerPlugin } from '@capacitor/core';
const Reminders = registerPlugin('Reminders', {
    web: () => import('./web').then(m => new m.RemindersWeb()),
});
export * from './definitions';
export { Reminders };
//# sourceMappingURL=index.js.map